import React from 'react';
import {
  individualAlertColumns,
  individualHitColumns,
  corperateAlertColumns,
  corperateHitColumns
} from '../metadata';
import style from './index.scss';
import moment from 'moment';
import { ageFormatter } from '../../../../services/util.js';

const INDIVIDUAL_VIEW = 0;
const CORPORATE_VIEW = 1;

const ComparisonItems = ({
  buId,
  data,
  isCollapsed,
  onTogglePastHitsModal
}) => {
  if (!isCollapsed) {
    if (data) {
      const { alert = {}, hits = [] } = data;
      const alertMetaData =
        buId === INDIVIDUAL_VIEW
          ? individualAlertColumns
          : corperateAlertColumns;
      const hitMetaData =
        buId === INDIVIDUAL_VIEW ? individualHitColumns : corperateHitColumns;

      return alertMetaData.map((metaDataItem, idx) => {
        // loop hits first for their value respective to metadata
        // to get array of hit information
        const hitItems = [];
        let customerWatchName = '';
        if (Array.isArray(hits) && hits.length > 0) {
          hits.forEach((currentHitItem, hitIdx) => {
            const { hit = {} } = currentHitItem;
            if (!customerWatchName) {
              customerWatchName = hit['customerMatchName'];
            }
            if (hitMetaData[idx].id === 'pastHitsCount') {
              const hitPayload = {
                watchlistId: hit.watchlistId,
                bankCustomerId: hit.bankCustomerId,
                limit: 5
              };
              hitItems.push(
                <td key={`hit-${hitIdx}-${hitMetaData[idx].id}`}>
                  <a
                    href="javascript:void(0)"
                    onClick={
                      onTogglePastHitsModal
                        ? () => onTogglePastHitsModal(hitPayload)
                        : null
                    }>
                    {currentHitItem.pastHitsCount !== null &&
                    currentHitItem.pastHitsCount !== undefined &&
                    String(currentHitItem.pastHitsCount)
                      .trim()
                      .toUpperCase() !== 'NAN'
                      ? currentHitItem.pastHitsCount
                      : '0'}
                  </a>
                </td>
              );
            } else {
              hitItems.push(
                <td key={`hit-${hitIdx}-${hitMetaData[idx].id}`}>
                  {hit[hitMetaData[idx].id] !== null &&
                  hit[hitMetaData[idx].id] !== undefined &&
                  String(hit[hitMetaData[idx].id]).trim().toUpperCase() !==
                    'NAN'
                    ? formatColumn(hit, hitMetaData[idx].id)
                    : '-'}
                </td>
              );
            }
          });
        }

        return (
          <tr key={`alert-${idx}-${metaDataItem.id}`}>
            <td>{metaDataItem.name}</td>
            {metaDataItem.id === 'customerMatchName' ? (
              <td>{customerWatchName ? customerWatchName : '-'}</td>
            ) : (
              <td>
                {alert[metaDataItem.id] &&
                String(alert[metaDataItem.id]).trim().toUpperCase() !== 'NAN'
                  ? formatColumn(alert, metaDataItem.id)
                  : '-'}
              </td>
            )}
            {hitItems}
          </tr>
        );
      });
    }

    return null;
  }

  return null;
};

const formatColumn = (data, key) => {
  let value = data[key];
  if (key === 'dobWatchlist') {
    return moment(value).format('DD/MM/YYYY');
  }
  if (key === 'partyAge' || key === 'watchlistAge') {
    return ageFormatter(value);
  }
  if (key === 'relatedPartyNames' || key === 'watchlistRelatedPartyNames') {
    return value.replace(/\[|\]|\'/g, '');
  }
  return value;
};
const ComparisonSection = ({
  data,
  isCollapsed,
  onToggleCollapseState,
  buId,
  onTogglePastHitsModal
}) => {
  if (data) {
    let collapsedClass = 'fa fa-angle-down';
    if (!isCollapsed) {
      collapsedClass = 'fa fa-angle-up';
    }

    return [
      <tr className={style.collapsibleRow}>
        <td colSpan="100%">
          <p>
            <i onClick={onToggleCollapseState} className={collapsedClass}></i>
            <b>Comparison Section</b>
          </p>
        </td>
      </tr>,
      <ComparisonItems
        data={data}
        isCollapsed={isCollapsed}
        onTogglePastHitsModal={onTogglePastHitsModal}
        buId={buId}
      />
    ];
  }

  return null;
};

export default ComparisonSection;
